import Hero from "./HeroSection/Hero";
import Payment from "./Paydets/Payment";
import Goals from "./Goals/Goals";
import Features from "./Features/Features";
import Download from "./Download/Download";
import Footer from "./Footer/Footer";

function App() {
  return (
    <div className="App">
      <Hero />
      <Payment />
      <Goals />
      <Features />
      <Download />
      <Footer />
    </div>
  );
}

export default App;
